<template>
  <div class="d-flex align-center hovervisible-activator">
    <v-text-field v-model.number="budgetAmountInProgress" :placeholder="$t('ELEMENT-DETAIL.AMOUNT_INPROGRESS')" type="number">
    </v-text-field>
    <span class="mx-1">/</span>
    <v-text-field v-model.number="budgetAmount" :placeholder="$t('ELEMENT-DETAIL.AMOUNT')" type="number">
    </v-text-field>
    <v-select v-model="budgetIcon" :items="budgetIcons" class="mx-1" style="min-width: max-content">
    </v-select>
    <v-select v-model="budgetState" :items="budgetStatesItems" style="min-width: max-content">
    </v-select>
    <v-btn-icon v-if="canDelete" size="small" color="errorred" class="hovervisible-item ml-1"
                @click="$emit('remove-budget-item')">
      <v-icon>far fa-trash-alt</v-icon>
      <v-tooltip location="bottom" activator="parent">{{ $t('ELEMENT-DETAIL.DELETE_BUDGET_ITEM') }}</v-tooltip>
    </v-btn-icon>
  </div>
</template>

<script>
  export default {
    props: {
      el: { type: Object, required: true },
      budget: { type: Object, required: true },
      budgetIcons: { type: Array, required: true },
      budgetStatesItems: { type: Array, required: true },
      canDelete: { type: Boolean, default: false },
    },
    emits: ['remove-budget-item'],
    computed: {
      budgetAmountInProgress: {
        get() {
          return this.budget.amount_inprogress;
        },
        set(newVal) {
          this.saveItem('amount_inprogress', newVal);
        },
      },
      budgetAmount: {
        get() {
          return this.budget.amount;
        },
        set(newVal) {
          this.saveItem('amount', newVal);
        },
      },
      budgetIcon: {
        get() {
          return this.budget.icon;
        },
        set(newVal) {
          this.saveItem('icon', newVal);
        },
      },
      budgetState: {
        get() {
          return this.budget.state;
        },
        set(newVal) {
          this.saveItem('state', newVal);
        },
      },
    },
    methods: {
      saveItem(prop, newVal) {
        if (! this.el.getBudgets()) { // first save -> add default item before modification
          this.el.setBudgets([this.budget]);
        }
        this.el.setBudgetsItem(this.budget, { [prop]: newVal });
      },
    },
  };
</script>
